"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var AmenityItem_1 = __importDefault(require("./AmenityItem"));
var lodash_1 = require("lodash");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AmenityList = function (_a) {
    var amenities = _a.amenities;
    var t = react_i18next_1.useTranslation('common').t;
    var translatedData = react_1.useMemo(function () {
        return amenities.reduce(function (acc, item) {
            if (!lodash_1.isUndefined(item.data) &&
                !lodash_1.isNull(item.data) &&
                item.data.length) {
                acc.push(__assign(__assign({}, item), { title: t(item.title) }));
            }
            return acc;
        }, []);
    }, [amenities]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.bl_amenity_list }, translatedData.map(function (amenity, index) { return (react_1.default.createElement(AmenityItem_1.default, __assign({ key: index }, amenity))); })));
};
exports.default = AmenityList;
